export default __webpack_public_path__ + "static/media/portfolioApp.149bf892.png";